export const APP_WEBVIEW_USER_AGENT_PATTERN = /(highstreet|napp)/i;

export const isAppWebviewUserAgent = (userAgent = '') =>
  APP_WEBVIEW_USER_AGENT_PATTERN.test(userAgent);
